export default __webpack_public_path__ + "static/pendant-59d10978586379e6dab04feadbbe8dc1.png";